<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Atendimento</p>
        </div>

        <div class="muven-content">
            <div class="muven-card muven-card-md muven-card-centered">
                <div class="muven-card-title">
                    <p>Como podemos ajudar?</p>
                </div>

                <div class="list-options-container">
                    <div class="item-option">
                        <div class="item-option-active" @click="gotoSupport()">
                            <p class="item-option-title">Suporte</p>
                            <p class="item-option-description">Para tirar dúvidas, enviar sugestões ou resolver problemas, basta clicar aqui</p>
                            <fa icon="chevron-right" class="item-option-icon" />
                        </div>
                    </div>

                    <div class="item-option">
                        <div class="item-option-active" @click="gotoBilling()">
                            <p class="item-option-title">Faturamento</p>
                            <p class="item-option-description">Para visualizar os boletos e notas referentes às cobranças do Muven, basta clicar aqui</p>
                            <fa icon="chevron-right" class="item-option-icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SupportView',
    methods: {
        gotoSupport() {
            window.open("https://www.karoo.com.br/chat/#/entrada?conta=275", "_blank")
        },
        gotoBilling() {
            this.$router.push('/atendimento/faturamento')
        },
    },
}
</script>
